import { defineStore } from 'pinia';
import { ref } from 'vue';

// 赛事类型常量
export enum RaceCategory {
    AI_MODEL = 'ai_model', // AI大模型赛
    DATA_ALGORITHM = 'data_algorithm', // 数据算法赛
    ENGINEERING = 'engineering', // 工程开发赛
    DAILY_LEARNING = 'daily_learning', // 日常学习赛
    OPERATOR = 'operator', // 算子赛
    NORMAL = 'normal', // 普通赛
}

// Tab 类型
export type EventsTab = 'activity' | 'competition';

const useEventsStore = defineStore(
    'events',
    () => {
        const activeTab = ref<EventsTab>('competition');

        // 从路由参数中获取tab值，支持 tab 和 activeTab 参数
        const getTabFromQuery = (query: Record<string, any>): EventsTab => {
            // 优先从 activeTab 参数获取
            const activeTabParam = query.activeTab as string;
            if (activeTabParam === 'activity' || activeTabParam === 'competition') {
                return activeTabParam as EventsTab;
            }
            // 其次从 tab 参数获取
            const tabParam = query.tab as string;
            if (tabParam === 'activity' || tabParam === 'competition') {
                return tabParam as EventsTab;
            }
            // 默认返回 activity
            return 'activity';
        };

        const setActiveTab = (tab: EventsTab) => {
            activeTab.value = tab;
        };

        return {
            RaceCategory,
            activeTab,
            getTabFromQuery,
            setActiveTab,
        };
    },
    {
        persist: {
            key: 'events-store',
            storage: localStorage,
            paths: ['activeTab'], // 持久化 activeTab
        },
    }
);

export default useEventsStore;
